import CloseIcon from '@mui/icons-material/Close';
import { IconButton, IconButtonProps } from '@mui/material';

export type CloseButtonProps = IconButtonProps;

const CloseButton: React.FC<CloseButtonProps> = (props) => {
  return (
    <IconButton {...props}>
      <CloseIcon fontSize={props.size} />
    </IconButton>
  );
};

export default CloseButton;
